const SHADOW_ROOT = document.querySelector("#acc").shadowRoot;
window.ACC_TABLE_ACTIVE_KEYS = {}

class Table {
    constructor(root) {
        this.initHeader(root);
    }

    initHeader(root){
        const headerRow = root.querySelector('[data-acc-table-header-row]');

        this.initMobileToggle(headerRow);
        this.initStickyness(root, headerRow);
    }

    initStickyness(root, headerRow){
        const spacer = root.querySelector('[data-acc-table-header-row-spacer]');
        let state = 'top';

        document.addEventListener('scroll', () => {
            if(root.closest('[data-acc-tab]').style.display === 'none'){
                return;
            }

            const rootBounding = root.getBoundingClientRect();
            const headerRowHeight = headerRow.clientHeight;
            const topEdgeOffset = SHADOW_ROOT.querySelector('[data-acc-tab-navigation-outer]')?.getBoundingClientRect().bottom;

            let newState =  'top';
            if(rootBounding.bottom < topEdgeOffset + headerRowHeight){
                newState = 'bottom';
            }else if(rootBounding.top < topEdgeOffset){
                newState = 'sticky';
            }

            if(state === newState){
                return;
            }

            state = newState;

            if(state === 'top'){
                headerRow.style.removeProperty('position');
                headerRow.style.removeProperty('top');
                headerRow.style.removeProperty('bottom');
                headerRow.style.removeProperty('width');
                spacer.style.setProperty('display', 'none');
                spacer.style.removeProperty('height');
                return;
            }

            if(state === 'sticky'){
                headerRow.style.setProperty('position', 'fixed');
                headerRow.style.setProperty('top', `${topEdgeOffset}px`);
                headerRow.style.removeProperty('bottom');
                headerRow.style.setProperty('width', `${rootBounding.width}px`);
                spacer.style.setProperty('display', 'block');
                spacer.style.setProperty('height', `${headerRowHeight}px`);
                return;
            }

            if(state === 'bottom'){
                headerRow.style.setProperty('position', 'absolute');
                headerRow.style.removeProperty('top');
                headerRow.style.setProperty('bottom', '0px');
                headerRow.style.setProperty('width', `${rootBounding.width}px`);
                spacer.style.setProperty('display', 'block');
                spacer.style.setProperty('height', `${headerRowHeight}px`);
                return;
            }
        })
    }

    initMobileToggle(headerRow){
        headerRow.querySelectorAll('[data-acc-table-header-button-key]').forEach(button => {
            const key = button.getAttribute('data-acc-table-header-button-key');
            const value = button.getAttribute('data-acc-table-header-button-value');

            // Set initial value
            if(!window.ACC_TABLE_ACTIVE_KEYS[key]){
                window.ACC_TABLE_ACTIVE_KEYS[key] = value;
            }

            button.addEventListener('click', () => {
                if(value === window.ACC_TABLE_ACTIVE_KEYS[key]){
                    // Same button clicked again
                    return;
                }

                const oldValue = window.ACC_TABLE_ACTIVE_KEYS[key];

                // Update columns globally
                SHADOW_ROOT.querySelectorAll(`.acc [data-acc-table-header-cell-key="${key}"][data-acc-table-header-cell-value="${oldValue}"]`).forEach(el => el.classList.add('column-hidden'));
                SHADOW_ROOT.querySelectorAll(`.acc [data-acc-table-header-cell-key="${key}"][data-acc-table-header-cell-value="${value}"]`).forEach(el => el.classList.remove('column-hidden'));

                // Update buttons globally
                SHADOW_ROOT.querySelectorAll(`.acc [data-acc-table-header-button-key="${key}"][data-acc-table-header-button-value="${oldValue}"]`).forEach(el => el.classList.remove('active'));
                SHADOW_ROOT.querySelectorAll(`.acc [data-acc-table-header-button-key="${key}"][data-acc-table-header-button-value="${value}"]`).forEach(el => el.classList.add('active'));
                
                // Update global value
                window.ACC_TABLE_ACTIVE_KEYS[key] = value;
            })
        })
    }
}

SHADOW_ROOT.querySelectorAll("[data-acc-table]").forEach(table => {
    new Table(table);
});
